import { registerUser } from './usermanagement';

// Action Types
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_ERROR = 'REGISTER_ERROR';

// Thunk Action for Register
export const registerUserAction = (data) => async (dispatch) => {
  try {
    const response = await registerUser(data);
    if (response && response.success) {
      dispatch({ type: REGISTER_SUCCESS, payload: response.data });
    } else {
      dispatch({ type: REGISTER_ERROR, payload: response.message || 'Registration failed' });
    }
  } catch (error) {
    dispatch({ type: REGISTER_ERROR, payload: error.message || 'An error occurred' });
  }
};
